import React from 'react'
import {
  useConversationsPerDay,
  useConversationsPerWeek,
  agentScopeSuffix,
  useAgentName,
} from '../../hooks/analytics/useAnalytics'
import { AgentFilter } from '../../types/analyticsTypes'
import GranularitySwitchChart from './GranularitySwitchChart'

interface Props {
  agentId: AgentFilter
}

const ConversationsChart: React.FC<Props> = ({ agentId }) => {
  const agentName = useAgentName(agentId)
  const conversationsPerWeek = useConversationsPerWeek(agentId)
  const conversationsPerDay = useConversationsPerDay(agentId)

  return (
    <GranularitySwitchChart
      title={`Conversations${agentScopeSuffix(agentName)}`}
      valueLabel='Conversations'
      daily={{
        isLoading: conversationsPerDay.isLoading,
        isError: conversationsPerDay.isError,
        points: (conversationsPerDay.data ?? []).map(point => ({
          day: point.day,
          value: point.conversations,
        })),
      }}
      weekly={{
        isLoading: conversationsPerWeek.isLoading,
        isError: conversationsPerWeek.isError,
        points: (conversationsPerWeek.data ?? []).map(point => ({
          day: point.week_start,
          value: point.conversations,
        })),
      }}
      dailySubtitle={days =>
        `Conversations started per day (last ${days} days). Today is partial.`
      }
      weeklySubtitle={weeks =>
        `Conversations started per week (last ${weeks} weeks). The current week is partial.`
      }
    />
  )
}

export default ConversationsChart
